<template>
  <div class="app-header" id="appHeader">
      <div class="title" >
        <div class="block">
          <div class="demonstration" >
            <div class="title-r" >
              <img src="../../assets/images/header-logo-2.png" />
              <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" class="menu" :popper-append-to-body="false" :collapse="isCollapse">
                <el-menu-item index="1" style="width: 60px;margin-left: 20px;">首页</el-menu-item>
                <el-submenu index="2" popper-class="navTwo">
                  <template slot="title">行业动态</template>
                  <el-menu-item index="2-1">行业活动</el-menu-item>
                  <el-menu-item index="2-2">行业发展</el-menu-item>
                </el-submenu>
                <el-submenu index="4" popper-class="navTwo">
                  <template slot="title">协会工作</template>
                  <el-menu-item index="4-1">协会动态</el-menu-item>
                  <el-menu-item index="4-2">通知公告</el-menu-item>
                </el-submenu>
                <el-submenu index="3" popper-class="navTwo">
                  <template slot="title">会员天地</template>
                  <el-menu-item index="3-1">会员动态</el-menu-item>
                  <el-menu-item index="3-2">会员名录</el-menu-item>
                </el-submenu>
                <el-menu-item index="11">服务平台</el-menu-item>
                <el-submenu index="8" popper-class="navTwo">
                  <template slot="title">人才建设</template>
                  <el-menu-item index="8-1">培训交流</el-menu-item>
                  <el-menu-item index="8-2">行业精英</el-menu-item>
                  <el-menu-item index="8-3">专家库</el-menu-item>
                </el-submenu>
                <el-submenu index="5" popper-class="navTwo">
                  <template slot="title">优秀成果</template>
                  <el-menu-item index="5-1">获奖成果</el-menu-item>
                  <el-menu-item index="5-2">成果展示</el-menu-item>
                </el-submenu>
                <el-submenu index="6" popper-class="navTwo">
                  <template slot="title">行业自律</template>
                  <el-menu-item index="6-1">自律文件</el-menu-item>
                  <el-menu-item index="6-2">监督检查</el-menu-item>
                  <el-menu-item index="6-3">诚信建设</el-menu-item>
                </el-submenu>
                <el-submenu index="7" popper-class="navTwo">
                  <template slot="title">政策法规</template>
                  <el-menu-item index="7-1">政策法规</el-menu-item>
                  <el-menu-item index="7-2">标准规范</el-menu-item>
                  <el-menu-item index="7-3">其他</el-menu-item>
                </el-submenu>
                <el-submenu index="9" popper-class="navTwo">
                  <template slot="title">党建园地</template>
                  <el-menu-item index="9-1">党建文件</el-menu-item>
                  <el-menu-item index="9-2">党建活动</el-menu-item>
                  <el-menu-item index="9-3">党建品牌</el-menu-item>
                  <el-menu-item index="9-4">建党百年</el-menu-item>
                </el-submenu>
                <el-submenu index="10" popper-class="navTwo">
                  <template slot="title">关于我们</template>
                  <el-menu-item index="10-1">协会简介</el-menu-item>
                  <el-menu-item index="10-2">协会章程</el-menu-item>
                  <el-menu-item index="10-3">会长理事名单</el-menu-item>
                  <el-menu-item index="10-4">组织机构</el-menu-item>
                  <el-menu-item index="10-5">联系我们</el-menu-item>
                  <el-menu-item index="10-6">会员管理办法</el-menu-item>
                  <el-menu-item index="10-7">出版物</el-menu-item>
                </el-submenu>
                <el-menu-item index="12">加入协会</el-menu-item>
              </el-menu>
            </div>
          </div>
          
          <div class="f-d" v-if="currentPath === 'HomePage' || currentPath === 'homePage'  || currentPath === ''">
            <span>创新</span>
            <span>协调</span>
            <span>绿色</span>
            <span>开放</span>
            <span>共享</span>
            <!-- <span>协会向会员单位和行业同仁们拜年了！
祝大家新春快乐，阖家幸福！</span> -->
          </div>
          <div class="header-bg">
            <el-carousel class="banner" :interval="3000" v-if="currentPath === 'HomePage'  || currentPath === 'homePage' || currentPath === ''">
              <el-carousel-item v-for="item in images" :key="item" >
                <img :src="require('../../assets/images/banner/new/'+item)" height="400" />
              </el-carousel-item>
            </el-carousel>
          
            <div v-else-if="currentPath === 'IndustryDynamic'" >
              <img :src="require('../../assets/images/banner/new/banner4行业动态.jpg')" />
              <div class="bg-bottom"><span class="f-blod">行业动态</span></div>
            </div>
            <div v-else-if="currentPath === 'MemberClub'" >
              <img :src="require('../../assets/images/banner/new/会员天地.jpg')" />
              <div class="bg-bottom"><span class="f-blod">会员天地</span></div>
            </div>
            <div v-else-if="currentPath === 'AssociationWork'" >
              <img :src="require('../../assets/images/banner/new/banner_500k.jpg')" />
              <div class="bg-bottom"><span class="f-blod">协会工作</span></div>
            </div>
            <div v-else-if="currentPath === 'ExcellentAchievements'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/banner3优秀成果.jpg')" />
              <div class="bg-bottom"><span class="f-blod">优秀成果</span></div>
            </div>
            <div v-else-if="currentPath === 'IndustrySelfControlled'" >
              <img :src="require('../../assets/images/banner/new/banner5.jpg')" />
              <div class="bg-bottom"><span class="f-blod">行业自律</span></div>
            </div>
            <div v-else-if="currentPath === 'PoliciesRegulations'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/政策法规.jpg')" />
              <div class="bg-bottom"><span class="f-blod">政策法规</span></div>
            </div>
            <div v-else-if="currentPath === 'TalentDevelop'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/人才建设.jpg')" />
              <div class="bg-bottom"><span class="f-blod">人才建设</span></div>
            </div>
            <div v-else-if="currentPath === 'PartyBuildingGarden'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/党建1.jpg')" />
              <div class="bg-bottom2"><span class="f-blod">党建园地</span></div>
            </div>
            <div v-else-if="currentPath === 'SearchAdvisory'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/banner_500k.jpg')" />
              <div class="bg-bottom"><span class="f-blod">全站搜索</span></div>
            </div>
            <div v-else-if="currentPath === 'AboutUs' || currentPath === 'publication'" class="header-bg">
              <img :src="require('../../assets/images/banner/new/banner2关于我们.jpg')" />
              <div class="bg-bottom"><span class="f-blod">关于我们</span></div>
            </div>
            <div v-else class="header-bg">
              <img :src="require('../../assets/images/banner/new/banner_500k.jpg')" />
            </div>
          </div>
          <!-- <div v-show="activeIndex !== '1'" class="collapse-expand" @click="expandHeader" id="imgpro">
            <img class="img-po" :src="require('../../assets/images/tabshouqi.svg')" />
          </div> -->
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'common-header',
  data () {
    return {
      images: [
        'banner_500k.jpg',
        'banner2关于我们.jpg',
        'banner3优秀成果.jpg',
        'banner4行业动态.jpg',
      ],
      activeIndex: '1',
      isCollapse: false,
      currentPath:'',
      bgShow: true
    }
  },
  watch: {
    $route: {
      handler: function(val){
        console.log(val.name)
        this.currentPath = val.name
      }
    }
  },
  mounted(){
    if (!this.currentPath) {
      var url = window.location.href.split('/#/')
      var aaa = url[1].split('?')
      this.currentPath = aaa[0]
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      // document.getElementById('appHeader').style.height = '480px'
      // document.getElementById('imgpro').style.display = 'block'
      this.bgShow = true
      this.activeIndex = keyPath[0]
      let returnPath = ''
      switch (key) {
          case '1':
            returnPath = '/' //首页
            break
          case '2-1':
            returnPath = '/IndustryDynamic?tab=1'//行业动态--行业活动
            break
          case '2-2':
            returnPath = '/IndustryDynamic?tab=2'//行业动态--行业发展
            break
          case '3-1':
            returnPath = '/MemberClub?tab=1'//会员天地--会员动态
            break
          case '3-2':
            returnPath = '/MemberClub?tab=2'//会员天地--会员名录
            break
          case '4-1': 
            returnPath = '/AssociationWork?tab=1'//协会工作--协会动态
            break
          case '4-2': 
            returnPath = '/AssociationWork?tab=2'//协会工作--通知公告
            break
          case '5-1': 
            returnPath = '/ExcellentAchievements?tab=1'//优秀成果--获奖成果
            break
          case '5-2': 
            returnPath = '/ExcellentAchievements?tab=2'//优秀成果--成果展示
            break
          case '6-1':
            returnPath = '/IndustrySelfControlled?tab=1'//行业自律--自律文件
            break
          case '6-2':
            returnPath = '/IndustrySelfControlled?tab=2'//行业自律--监督检查
            break
          case '6-3':
            returnPath = '/IndustrySelfControlled?tab=3'//行业自律--诚信建设
            break
          case '7-1':
            returnPath = '/PoliciesRegulations?tab=1'//政策法规--政策法规
            break
          case '7-2':
            returnPath = '/PoliciesRegulations?tab=2'//政策法规--标准规范
            break
          case '7-3':
            returnPath = '/PoliciesRegulations?tab=3'//政策法规--其他
            break
          case '8-1':
            returnPath = '/TalentDevelop?tab=1'//人才建设--培训交流
            break
          case '8-2':
            returnPath = '/TalentDevelop?tab=2'//人才建设--行业精英
            break
          case '8-3':
            returnPath = '/TalentDevelop?tab=3'//人才建设--专家库
            break
          case '9-1':
            returnPath = '/PartyBuildingGarden?tab=1'//党建园地--党建文件
            break
          case '9-2':
            returnPath = '/PartyBuildingGarden?tab=2'//党建园地--党建活动
            break
          case '9-3':
            returnPath = '/PartyBuildingGarden?tab=3'//党建园地--党建品牌
            break
          case '9-4':
            returnPath = '/PartyBuildingGarden?tab=4'//党建园地--党建百年
            break
          case '10-1':
            returnPath = '/AboutUs?tab=1'//协会简介
            break
          case '10-2':
            returnPath = '/AboutUs?tab=2'//协会章程
            break
          case '10-3':
            returnPath = '/AboutUs?tab=3'//会长理事名单
            break
          case '10-4':
            returnPath = '/AboutUs?tab=4'//组织结构
            break
          case '10-5':
            returnPath = '/AboutUs?tab=5'//联系我们
            break
          case '10-6':
            returnPath = '/AboutUs?tab=6'//会员管理办法
            break
          case '10-7':
            returnPath = '/PublicationList'//出版物
            break
          case '11': 
            returnPath = '/#target'//服务平台--跳转至首页定位处：服务平台
            this.activeIndex = '1'
            break
          case '12': 
            returnPath = '/AboutUs?tab=7'//加入协会
            break           
          default:
            returnPath = '/' //首页
      }
      if (key === '11') {
        console.log('首页首页首页首页',returnPath)
        this.$router.push({path: '/#target'})
        this.$nextTick(() => {
          const returnEle = document.querySelector("#target");  //productId是将要跳转区域的id
          if (!!returnEle) {
            returnEle.scrollIntoView(true); // true 是默认的
          }
        });
      } else {
        return this.handleJump(returnPath)
      }
    },
    handleJump(path, param){
      this.$router.push({
          path: path,
          query: param
      }, () => {})
    },
    expandHeader(){
      // document.getElementById('appHeader').style.height = '70px'
      // document.getElementById('appHeader').style.background = '#164DA0'
      // document.getElementById('imgpro').style.display = 'none'
      // this.bgShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import './Header.scss';
</style>
<style lang="scss">
  .block{
    text-align: left;
    position: relative;
    .demonstration{
      background-color: rgba(0,0,0,0.3);
      height: var(--titleHeight);
      position: absolute;
      display: flex;
      margin: 0 auto;
      z-index: 9;
      margin-top: 0px;
      width: 100%;
      border-bottom: solid 1px rgb(255,255,255, 0.26);
      .title-r{
        display: flex;
        img{
          height: var(--logoHeight);
          margin: var(--logoMargin);
        }
        margin: 0 auto;
          position: relative;
          .menu{
            display: flex;
            white-space: nowrap;      
          }
          .el-menu{
            height: var(--titleMenuH);
            background: none;
          }
          .el-menu.el-menu--horizontal{
            border: none;
          }
          .el-menu--horizontal>.el-menu-item.is-active{
            color: var(--fontColor);
            font-size: var(--fontSize);
            font-weight: 600;
          }
          .el-submenu__title{
            width: 100px;
          }
          .el-menu--horizontal>.el-submenu .el-submenu__title{
            margin-top: var(--titleTabMT);
            color: var(--fontColor);
            font-size: var(--fontSize);
            font-weight: 600;
          }
          .el-menu--horizontal>.el-menu-item{
            width: 100px;
            text-align: center;
            height: var(--titleMenuItemH);
            margin-top: var(--titleTabMT);
            color: var(--fontColor);
            font-size: var(--fontSize);
            font-weight: 600;
          }
          .el-submenu__title i{
            color: var(--fontColor);
            font-size: var(--fontSize);
            font-weight: 600;
          }
          .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: none;
          }
          .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
            background: none;
          }
          .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
            background: none;
          }
          .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
            height: var(--titleMenuItemH);
            border-bottom: none;
          }
          .el-icon-arrow-down:before{
            display: none;
          }
      }
    }
    .banner{
      position:relative;
      img{
          width: 100%;
          height: 100%;
          object-fit:cover;
      }      
    }
    .el-carousel__container{
      height: var(--headerH);
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }
    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }
    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
  }
</style>
